import MuiTab, { TabProps as PropsTab } from '@material-ui/core/Tab'
import MuiTabs from '@material-ui/core/Tabs'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import * as React from 'react'

import { scrollBar } from '../base'

export type TabProps = {
  customSize?: 'medium' | 'small'
  tabs?: string[]
  setSelected: (value: number) => void
} & PropsTab

const tabsStyle: object = {
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '24px',
  border: '1px #D3DFE6 solid',
  padding: '8px 20px',
  maxWidth: '100%',
  color: '#1A4D6A'
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabs: {
      '& .MuiTab-root': {
        minHeight: 48,
        minWidth: 142
      },
      '& .MuiTabs-fixed': {
        ...scrollBar
      }
    },
    tabSmall: {
      '& .MuiTab-root': {
        minHeight: 34,
        minWidth: 138,
        fontSize: 13
      }
    },
    first: {
      borderRadius: '4px 0px 0px 4px',
      ...tabsStyle
    },
    last: {
      borderRadius: '0px 4px 4px 0px',
      ...tabsStyle
    },
    tab: {
      ...tabsStyle
    },
    selected: {
      background: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    indicator: {
      backgroundColor: 'transparent'
    }
  })
)

export const Tabs: React.FC<TabProps> = (props) => {
  const classes = useStyles()
  const { tabs = [], setSelected, value, customSize } = props
  const getTabStyle = (index: number) => {
    const style = { selected: classes.selected }
    if (index === 0) {
      return { ...style, root: classes.first }
    } else if (index === tabs.length - 1) {
      return { ...style, root: classes.last }
    } else {
      return { ...style, root: classes.tab }
    }
  }
  const handleChange = (event: React.ChangeEvent<object>, newValue: number) => {
    setSelected(newValue)
  }
  return (
    <div>
      <MuiTabs
        className={customSize === 'small' ? classes.tabSmall : classes.tabs}
        classes={{ indicator: classes.indicator }}
        value={value ? value : 0}
        onChange={handleChange}
      >
        {tabs.map((tab, index) => (
          <MuiTab
            key={`tab-${index}`}
            classes={getTabStyle(index)}
            label={tab}
            value={index}
          />
        ))}
      </MuiTabs>
    </div>
  )
}

export default Tabs